import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { _isId } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class VaultService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllVault(page, size, search) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Vault,
      queryString: `page=${page}&size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdVault(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Vault,
    }, id);
    return await firstValueFrom(observable);
  }

  async getAllCompanyByIdVaultMovement(page, size, id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.CompanyVaultMovement,
      action: "GetByIdCompanyVaultMovements",
      queryString: `page=${page}&size=${size}&companyId=${id}`
    });
    return await firstValueFrom(observable);
  }

  async createVault(title: string, description: string, kindId: number) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Vault,
    }, {
      title: title,
      description: description,
      kindId: kindId
    });
    return await firstValueFrom(observable);
  }

  async updateVault(id: number, title: string, description: string, kindId: number) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Vault,
    }, {
      id: id,
      title: title,
      description: description,
      kindId: kindId
    });
    return await firstValueFrom(observable);
  }

  async createCompanyVaultMovement(vaultId: number, balance: number, kindId: number, appUserId: number, companyId: number, description?: string, projectId?: number, transactionManagementId?: number,vaultDate?:Date) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.CompanyVaultMovement,
    },
      {
        vaultId: vaultId,
        description: description,
        balance: balance,
        kindId: kindId,
        appUserId: appUserId,
        companyId: companyId,
        projectId: projectId,
        transactionManagementId: transactionManagementId,
        vaultDate:vaultDate
      });
    return await firstValueFrom(observable);
  }

  async createVaultVaultMovement(vaultId: number, balance: number, kindId: number, appUserId: number, transferVaultId: number, description?: string, vaultDate?: Date) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.VaultVaultMovement,
    },
      {
        vaultId: vaultId,
        description: description,
        balance: balance,
        kindId: kindId,
        appUserId: appUserId,
        transferVaultId: transferVaultId,
        vaultDate: vaultDate
      });
    return await firstValueFrom(observable);
  }

  async updateCompanyVaultMovement(id: number, vaultId: number, balance: number, appUserId: number, projectId?: number, vaultDate?: Date) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.CompanyVaultMovement,
    }, {
      id: id,
      vaultId: vaultId,
      balance: balance,
      appUserId: appUserId,
      projectId: projectId,
      vaultDate: vaultDate
    });
    return await firstValueFrom(observable);
  }

  async updateVaultVaultMovement(id, balance,description) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.VaultVaultMovement
    }, {
      id:id,
      balance:balance,
      description:description,
      appUserId:_isId
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
